import React, { useEffect, useState } from "react";
import styles from '../../css/Part2.module.css';

const MilestoneSection = () => {
  const [imageSrc, setImageSrc] = useState("images/background/Group 111.png");

  const updateImage = () => {
    if (window.innerWidth <= 500) {
      setImageSrc("images/background/Milestonemobileupdate.png"); // Mobile image
    } else {
      setImageSrc("images/background/Milestonedesktop.png"); // Desktop image
    }
  };

  useEffect(() => {
    // Call updateImage on component mount and window resize
    updateImage();
    window.addEventListener('resize', updateImage);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('resize', updateImage);
    };
  }, []); // Empty dependency array means this effect runs once when the component mounts

  return (
    <section className={styles.milestoneSection}>
      <div className={styles.milestoneContainer}>
        <div className={styles.milestoneContent}>
          <img
            src={imageSrc}
            alt="Milestone Background"
            className={styles.milestoneBoxImage}
          />
        </div>
      </div>
    </section>
  );
};

const AboutUs = () => {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <img src="images/background/Background effect.png" alt="Background2" className={styles.backgroundImage} />
        <div className={styles.contentWrapper}>
          <img src="images/team/Our Team all.jpg" alt="our team" className={styles.mainImage} />
          <div className={styles.imageTextContainer}>
            <img src="images/background/Coin.png" alt="coin" className={styles.decorativeImage} />
            <div className={styles.textContent}>
              <h1 className={styles.mainTitle}>Our Company</h1>
              <p className={styles.description}>
                FoneApp aims to build a strong community of consumers who shop naturally with participating merchants, both online and in-store, 
                using a secure and efficient digital platform. This allows both consumers and merchants to enjoy endless rewards together.
                <br /><br />
                Silverlake Innovation Partners (SIP) is part of the Silverlake group of companies, serving Financial Institute & Enterprises 
                (Public or Private) regionally via the role of System Integrator. FoneApp is a member company of SIP. It provides strong software 
                solutions and Business know-how in Digital Spending, Loyalty and their unique & proven Hyper-Rewards program.
              </p>
            </div>
          </div>
        </div>
        <img src="images/background/Coin1.png" alt="coin1" className={styles.bottomImage} />
      </div>

      {/* Render the MilestoneSection component */}
      <MilestoneSection />
    </section>
  );
};

export default AboutUs;
